module.exports = __webpack_public_path__ + "static/media/b.95a69429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b.png
// module id = 560
// module chunks = 27